import { useQuery } from '@tanstack/react-query';
import { fetchAssignableGroupsForDealer } from '../services/security-groups';

interface Params {
  dealerId: string | null;
  search?: string;
  page?: number;
  per_page?: number;
}

export function useAssignableGroupsForDealerQuery({ dealerId, search, page = 1, per_page = 200 }: Params) {
  return useQuery({
    queryKey: ['security', 'dealers', dealerId, 'assignable-groups', { search, page, per_page }],
    queryFn: () => fetchAssignableGroupsForDealer(dealerId as string, { search, page, per_page }),
    enabled: Boolean(dealerId),
    placeholderData: (prev) => prev,
  });
}
